import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/dxb/Digital_footprint.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Building Robust, Performance-Oriented & User-Focused Web Solutions
              for Businesses of Future
            </h2>
            <p>
              TekRevol is on a mission to revolutionize the GCC landscape by
              empowering local businesses and bridging the gap between
              technology and the local population. We have built several web
              solutions that continue to deliver exceptional results to our
              clients and open new pathways to explore and ascend to new heights
              of success.
            </p>
            <p>
              Over the years, we have thrived on our will to reshape the
              technology influence and how the world perceives it. Not as a mere
              tool to ease, we wish to see technology as a medium to a new
              world, a more engrossed society. Our top-rated web development
              services are exactly what you need to upscale and win the future
              years for your business – we are on a path that no one has taken –
              come, partner with us.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let's Take Your Brand Online
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
